export default __webpack_public_path__ + "6bab12731cdc7898542ea41fc8bed105.jpg";